import { render } from "./Explanation.vue?vue&type=template&id=1a535b91"
import script from "./Explanation.vue?vue&type=script&lang=js"
export * from "./Explanation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/UserGuide/Explanation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a535b91"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a535b91', __exports__)) {
    api.reload('1a535b91', __exports__)
  }
  
  module.hot.accept("./Explanation.vue?vue&type=template&id=1a535b91", () => {
    api.rerender('1a535b91', render)
  })

}


export default __exports__